import {
  bestExerciseValue,
  cardCapApplies,
  countExerciseSuccesses,
  evaluateGoals,
  evaluateGroup,
  firstGoalFocus,
  firstRewardMoment,
  goalStartTempo,
  guidedFocus,
  guidedMoment,
  heldFromInput,
  heldFromPractice,
  newGoalMaterial,
  playAlongRoundSummary,
  PRACTICE_SOURCE_TEXTS,
  practiceSourceNotice,
  practiceTally,
  questState,
  recordCardResult,
  recordExerciseResult,
  rewardOrder,
  shownRunTally,
  trialRoundNote,
} from './index';

Object.assign(globalThis, {
  PiandojoQuest: Object.freeze({
    bestExerciseValue,
    cardCapApplies,
    countExerciseSuccesses,
    evaluateGoals,
    evaluateGroup,
    firstGoalFocus,
    firstRewardMoment,
  goalStartTempo,
    guidedFocus,
    guidedMoment,
    heldFromInput,
    heldFromPractice,
    newGoalMaterial,
    playAlongRoundSummary,
    PRACTICE_SOURCE_TEXTS,
    practiceSourceNotice,
    practiceTally,
    questState,
    recordCardResult,
    recordExerciseResult,
    rewardOrder,
    shownRunTally,
    trialRoundNote,
  }),
});
